import * as cardsApi from '@/network/api/cards/cards.api.js'
import * as cardlessWithdrawApi from '@/network/api/cardlesswithdrawal.api.js'
import * as favoritesApi from '@/network/api/favorites.api.js'

/** requests Cards List
@return {promise} - Cards request
*/
export const requestCards = async (context, payload) => {
    const res = await cardsApi.cards(payload)

    if (res) context.commit('SAVE_CARDS', res.data.data)
    return res
}

/** requests Amounts List
@return {promise} - Amounts List request
*/
export const requestAmountsList = async (context, payload) => {
    const res = await cardlessWithdrawApi.requestAmountsList(payload)

    if (res) context.commit('SAVE_AMOUNTS_LIST', res.data.data)
    return res
}

/**
@return {promise} - Creates Cardless Withdraw
*/
export const createCardlessWithdraw = async (context, payload) => {
    const res = await cardlessWithdrawApi.createCardlessWithdraw(payload)

    return res
}

/** requests Favorites List
@return {promise} - Tabs request
*/
export const requestFavorites = async (context, payload) => {
    const res = await favoritesApi.getFavoritesList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_FAVORITES', { pageNumber: payload.pageNumber, data: data })
    }
    return res
}

/** updates operation favorite status */
export const updateFavoriteStatus = async (context, payload) => {
    context.commit('UPDATE_FAVORITE_STATUS', payload)
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
